// extracted by mini-css-extract-plugin
module.exports = {"tooltipArrow":"_b809a4e","container":"_2e2777c","title":"_a224e14","gamesInnerContainer":"_7cfbf13","containerMobile":"_c87c84c"};